import { Routes } from '@angular/router';
import { DashboardPrePrestador } from '@/features/registro/pre-prestador/dashboard-pre-prestador/dashboard-pre-prestador';
import { PrePrestadorContent } from '@/features/registro/pre-prestador/pre-prestador-content';
import { DashboardPreMedico } from '@/features/registro/pre-medico/dashboard-pre-medico/dashboard-pre-medico';

const rootPath = 'premedico';

/**
 * Define as rotas do módulo de Arrecadação:
 * - /arrecadacao: Rota principal que carrega o layout `ArrecadacaoContent`.
 * - Rota padrão ('') -> `DashboardArrecadacao`
 * - Rota 'relatorios' -> `Relatorios`
 */
export const preMedicoRoutes: Routes = [
    {
        path: rootPath,
        component: DashboardPreMedico,
        children: [{ path: '', component: DashboardPreMedico }]
    }
];
